import styled from 'styled-components';

import { Box } from '~/components/Box';

export const InlineFlex = styled(Box)`
  display: inline-flex;
  align-items: center;
`;
try {
    // @ts-ignore
    InlineFlex.displayName = "InlineFlex";
    // @ts-ignore
    InlineFlex.__docgenInfo = { "description": "", "displayName": "InlineFlex", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/InlineFlex/InlineFlex.tsx#InlineFlex"] = { docgenInfo: InlineFlex.__docgenInfo, name: "InlineFlex", path: "src/components/InlineFlex/InlineFlex.tsx#InlineFlex" };
}
catch (__react_docgen_typescript_loader_error) { }